import { Component, OnInit } from "@angular/core";
import { Data, Router } from "@angular/router";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { SyndicateRepositoryService } from "../../syndicate-repository.service";
import { HeaderComponent } from "../../../../components/header/header.component";

@Component({
    selector: "app-not-winning",
    templateUrl: "./not-winning.component.html",
    styleUrls: ["./not-winning.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class NotWinningComponent implements OnInit {
  pageTitle = "Leave syndicate";
  reason = "not-winning-enough";
  syndicateName: Data | string;
  constructor(
    public translate: TranslateService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private GTMSegment: GTMSegmentService,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
  ) {
    this.GTMSegment.GTMPopupInitialization("leaveSyndicateReasonPopup-4");
  }
  ngOnInit() {
    this.syndicateName = this.navParams?.data.s_name
    this.translate.get(['not-winning.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["not-winning.pageTitle"])
    }, err => { return (err) })
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

  leave() {
    this.modalCtrl.dismiss(this.reason).catch(err => { return err });
  }

  closeAndRedirect() {
    this.router.navigateByUrl("/mainTabs/tabs/game");
    this.syndicateService?.closeAllDialogs();
  }
}
